/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { getBaseServiceConfig } from 'apps/console-core/src/Services/_base';
import { useFileStoreMappingsServiceStore } from 'apps/console-core/src/State/fileStoreMappingsServiceStore';
import { FileStoreMappingsService } from '../../FileStoreMappings.service';
import { FileStoreMappingsServiceConfiguration } from '../../FileStoreMappings.service.config';

export const getFileStoreMappingsService = (): FileStoreMappingsService => {
  const baseServiceConfig = getBaseServiceConfig();

  const { updateFileStoreMappingsService, fileStoreMappingsService } = useFileStoreMappingsServiceStore.getState();

  if (!fileStoreMappingsService) {
    const fileStoreMappingsServiceConfig: FileStoreMappingsServiceConfiguration = baseServiceConfig;
    const newFileStoreMappingsService = new FileStoreMappingsService(fileStoreMappingsServiceConfig);

    updateFileStoreMappingsService(newFileStoreMappingsService);

    return newFileStoreMappingsService;
  }

  return fileStoreMappingsService;
};
